module.exports = __webpack_public_path__ + "static/media/clock.5aa9f169.svg";